import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";

var _this = this;

import { arrayToString } from '../helper/utils/common';
import { Ne, Pe, _n, r, i } from '../helper/utils/getHash'; //获取设备枚举 - 异步

export var asyncGetEnumerateDevices = function asyncGetEnumerateDevices() {
  if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
    // console.error('enumerateDevices() is not supported.')
    return;
  }

  return navigator.mediaDevices.enumerateDevices();
};
export var getEnumerateDevices = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var devicesArray, devices;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            devicesArray = [];
            _context.prev = 1;
            _context.next = 4;
            return asyncGetEnumerateDevices();

          case 4:
            devices = _context.sent;

            if (devices && devices.length > 0) {
              devices.forEach(function (device) {
                devicesArray.push("id=".concat(device.deviceId, ";gid=").concat(device.groupId, ";").concat(device.kind, ";"));
              });
            }

            _context.next = 10;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);

          case 10:
            return _context.abrupt("return", arrayToString(devicesArray));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));

  return function getEnumerateDevices() {
    return _ref.apply(this, arguments);
  };
}(); //fpjs pro

export var getEnumerateDevicesPro = function getEnumerateDevicesPro() {
  return r(_this, void 0, void 0, function () {
    var e, t, n;
    return i(this, function (r) {
      switch (r.label) {
        case 0:
          return (null == (e = navigator.mediaDevices) ? void 0 : e.enumerateDevices) ? (t = function t(e) {
            return e.slice(0, 32).replace(/([,\\])/g, '\\$1');
          }, n = function n(e) {
            return [t(e.deviceId), t(e.groupId), {
              audioinput: 'ai',
              audiooutput: 'ao',
              videoinput: 'vi'
            }[e.kind], t(e.label)].join(',');
          }, [4, Ne(Pe(250, -2), function () {
            return i(this, function (t) {
              switch (t.label) {
                case 0:
                  return [4, e.enumerateDevices()];

                case 1:
                  return [2, t.sent().map(n)];
              }
            });
          })]) : [2, ''];

        case 1:
          return [2, r.sent()];
      }
    });
  });
};